import { lazy, Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import {
  isMindMapEditorPath,
  useFullScreenStudyPageOpen,
  type TutorSubjectSwitch,
} from './studyTutorPanelLayout';

// Loaded on demand, so Study pages without the Tutor panel do not load its chat renderer.
const StudyTutorPanel = lazy(() =>
  import('./StudyTutorPanel').then((module) => ({ default: module.StudyTutorPanel })),
);

/**
 * Subject Space Tutor panel, loaded on demand (study-subject-tutor-panel-prd.md §3.1). The mind
 * map example viewer keeps its own full-screen UI: no panel and no phone launcher while it is
 * open (D-TPN-11). The mind map editor shows Tuan Tuan in its own layout (D-TPN-12), so this
 * slot never adds a second Tutor there.
 */
export function StudyTutorPanelSlot({
  subjectKey,
  subjectSwitch,
  onSetUp,
}: {
  subjectKey: string;
  subjectSwitch?: TutorSubjectSwitch;
  onSetUp?: () => void;
}) {
  const { pathname } = useLocation();
  const fullScreenOpen = useFullScreenStudyPageOpen();
  if (fullScreenOpen || isMindMapEditorPath(pathname)) return null;
  return (
    <Suspense fallback={null}>
      <StudyTutorPanel subjectKey={subjectKey} subjectSwitch={subjectSwitch} onSetUp={onSetUp} />
    </Suspense>
  );
}
